import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Desktop from './icon-desktop.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Desktop {...validProps} />;
}
SvgComponent.iconName = 'desktop';

/**
 * @deprecated This is a legacy icon
 */
export const DesktopIcon = svgIconWrapper(SvgComponent);
